import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config =  {
    name: 'product-lists',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' }
    ],
    endpoints: {
        productLists: '/product-lists',
        productList: '/product-lists/[id]'
    },
    defaults: {
        createProductList: {
            name: "",
            slug: "",
            position: 0,
            target: 'homepage',
            type: 'grid',
            active: 0,
            urlHref: '',
            urlTarget: '',
            hasMore: 0,
            products: []
        }
    },
    validations: {
        paymentType: yup.object().shape({
            name: yup.string().required("Numele este obligatoriu"),
            slug: yup.string().required("SLUG este obligatoriu"),
            products: yup.array()
        })
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
